<template>
    <div class="login">
      <div class="passImg" @click="closePass">
        <img src="../assets/back.png" />
      </div>
      <div class="content" :class="this.messageTitle=='修改密码'?' ':'isPosition'">
        <div class="passAll">
          <div class="passText">{{form.title}}</div>
        </div>
        <el-input
            :disabled="disabled"
            placeholder="请输入手机号"
            v-model="form.mobile">
            <div class="iconImg" slot="prefix">
              <img src="../assets/icon_phone.png" />
            </div>
        </el-input>
        <div style="display: flex;">
          <el-input
            style="margin-top: 0;flex: 1;"
            placeholder="请输入验证码"
            v-model="form.authCode">
			<div class="iconImg" slot="prefix">
			  <img src="../assets/icon_code.png" />
			</div>
          </el-input>
          <el-button type="primary" class="code2" slot="suffix" @click="sendYzm" :disabled="countDisable" >{{ count }}</el-button>
        </div>
        <el-input
            :type="flagPass?'text':'password'" auto-complete="new-password" ref="newPwdRef"
            placeholder="请输入新密码"
            v-model="form.password"
            >
            <div class="iconImg" slot="prefix">
              <img src="../assets/icon_psw.png" />
            </div>
			<div slot="suffix" :class="[flagPass?'openEye':'closeEye']" style="cursor: pointer;"
				autocomplete="auto" @click="flagPass=!flagPass">
			</div>
        </el-input>
        <el-input
			:type="flagPassNew?'text':'password'" auto-complete="new-password" ref="reNewPwdRef"
            placeholder="请输入确认密码"
            v-model="form.new_password"
            >
            <div class="iconImg" slot="prefix">
              <img src="../assets/icon_psw.png" />
            </div>
			<div slot="suffix" :class="[flagPassNew?'openEye':'closeEye']" style="cursor: pointer;"
				autocomplete="auto" @click="flagPassNew=!flagPassNew">
			</div>
        </el-input>
        <div style="display: flex;">
          <el-button type="primary" class="btn" @click="submit">提交</el-button>
          <el-button v-if="this.message==true" class="btnCancel" @click="cancel">取消</el-button>
        </div>
      </div>


    </div>
</template>
<script>
export default {
    props:['message','messageTitle','username'],
    data() {
        return {
          form:{
            mobile:"",
            authCode:"",
            password:"",
            new_password:"",
            title:"忘记密码"
          },
			flagPass: false,
			flagPassNew: false,
          count: "发送验证码",
          countDisable: false,
          inter:null,
          rePwdReadOnly:false,
          newPwdReadOnly:false,
          disabled:false,
        };
    },
    destroyed() {
        clearInterval(this.inter);
    },
    created() {
      if(this.messageTitle){
        this.form.title=this.messageTitle
      }
      if(this.messageTitle=="修改密码"){
        this.form.mobile=this.username
        this.disabled=true
      }

    },
    watch: {
    //监听输入框
      "form.password": function () {
        if (this.form.password === "") {
          this.newPwdReadOnly = true;
          this.newPwdFocus(null);
        }
      },
      "form.new_password": function () {
        if (this.form.new_password === "") {
          this.rePwdReadOnly = true;
          this.newPwdFocus(null, false);
        }
      }
    },
    methods:{
      //鼠标移入移出
      newPwdFocus(evt, isNew = true) {
        if (evt) {
          evt.stopPropagation();
          evt.preventDefault();
        }
        setTimeout(() => {
          if (isNew) {
            this.newPwdReadOnly = false;
          } else {
            this.rePwdReadOnly = false;
          }
        }, 100);
      },

      closePass(){
        this.$emit("closeBtn");
      },
      cancel(){
        this.$emit("closeBtn");
      },
      countDown() {
          let self = this;
          self.count = 60;
          self.countDisable = true;
          self.inter = setInterval(function () {
              // console.log("进来");
              if (self.count > 0) {
                  self.countDisable = true;
                  self.count--;
                  // console.log(self.count, "倒计时");
              } else {
                  clearInterval(self.inter);
                  self.count = "获取验证码";
                  self.countDisable = false;
                  self.inter = null;
              }
          }, 1000);
      },
      sendYzm() {
          let self = this;
          if (!this.form.mobile) {
              this.$message({
                  message: "请输入手机号",
                  type: "warning",
              });
              return;
          }
          let data = {
              mobile: this.form.mobile,
          };
          this.countDown();
          this.$http.post("api/sms", data).then((res) => {
              console.log(res, "返回验证码");
              if (res.code == 0) {
              } else {
                  self.count = "获取验证码";
                  self.countDisable = false;
                  this.$message({
                      message: res.msg,
                      type: "warning",
                  });
              }
          });
      },
      //忘记密码
      submit(){
		var regPass = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,12}$/
		if (!regPass.test(this.form.password)) {
		  this.$message({
		      message: "请输入8～12位字母/数字组合",
		      type: "warning",
		  });
		  this.form.password=""
		  this.form.new_password=''
		  return
		}
		if(this.form.new_password!=this.form.password){
			this.$message({
				message: "两次密码不一致",
				type: "warning",
			});
			this.form.password=""
			return
		}
        if(this.form.password==""||this.form.new_password==""){
          this.$message({
              message: "请输入密码",
              type: "warning",
          });
          this.form.password==""
          this.form.new_password=""
          return;
        }
        let data = {
            mobile: this.form.mobile,
            authCode:this.form.authCode,
            password: this.form.password,
            new_password: this.form.new_password,
        };

        this.$http.post("backend/up_password", data).then((res) => {

            if (res.code == 0) {
                var token = res.data.token;
                this.$message({
                    message: "修改成功",
                    type: "success",
                });
                this.closePass()
                clearInterval(this.inter);
                this.inter = null;
                this.form.mobile=""
                this.form.authCode=""
                this.form.password=""
                this.form.new_password=""
                this.code='获取验证码'
            } else {
                this.$message({
                    message: res.message,
                    type: "warning",
                });
            }
        });
      }
    }
};
</script>
<style scoped>
  .login{
    height: 100%;
    position: relative;
  }
  .login .content{
      width: 320px;
      /* padding: 0 32px; */
      padding-bottom: 42px;
      box-sizing: border-box;
      margin: 0 auto;
  }
  .login .isPosition{
    position: absolute;
    left: 50%;
    top: 120px;
    transform: translate(-50%, 0);
  }
  .login .el-input{
    margin-bottom: 20px;
  }
  .iconImg{
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 7px;

  }
  .iconImg img{
      width: 16px;
      display: block;
      padding-right: 12px;
      border-right: 1px solid #E1E4E9;
    }
  .login .btn{
    flex: 1;
    margin-top: 20px;
    height: 40px;
    background: #DB3323;
    border-radius: 2px;
  }
  .login .btnCancel{
    flex: 1;
    height: 40px;
    border-radius: 4px;
    margin-top: 24px;
  }
  .login .passAll{
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .passText{
    font-size: 24px;
    font-weight: 500;
    color: #333333;
    margin-bottom: 40px;
  }
  .passImg{
    position: absolute;
    top: 40px;
    right: 40px;
    cursor: pointer;
  }
  .passImg img{
    width: 20px;
  }
  .code{
    font-size: 12px;
    font-weight: 400;
    color: #FF5C1F;
    background: none;
    border: none;
    height: 100%;
  }
  .code.is-disabled:hover {
    color: #FF5C1F;
    background: none;
  }
  .code2{
    width: 102px;
    height: 38px;
    text-align: center;
    background: #DB3323;
    border-radius: 2px;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    margin-left: 12px;
    padding: 0;
    box-sizing: border-box;
    margin-top: 1px;
  }
  /deep/ .el-input{
    height: 40px;
    line-height: 40px;
  }
  /deep/ .el-input__inner{
	border-radius: 2px;
    height: 40px;
    line-height: 40px;
  }
	/deep/ .el-input__suffix {
		display: flex;
		align-items: center;
		right: 10px;
	}
  .closeEye{
    display: block;
    width: 16px;
    height: 16px;
    background: url(../assets/closeEye.png) no-repeat;
    background-size: 100% 100%;
  }
  .openEye{
    display: block;
    width: 16px;
    height: 16px;
    background: url(../assets/openEye.png) no-repeat;
    background-size: 100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/forgotPass.vue